import script from "./404Page.vue?vue&type=script&setup=true&lang=ts"
export * from "./404Page.vue?vue&type=script&setup=true&lang=ts"

import "./404Page.vue?vue&type=style&index=0&id=d4e9bc46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4e9bc46"]])

export default __exports__